/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PowercurveDataRepresentation
 */
export interface PowercurveDataRepresentation {
    /**
     * 
     * @type {Array<number>}
     * @memberof PowercurveDataRepresentation
     */
    windspeed: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PowercurveDataRepresentation
     */
    weight: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PowercurveDataRepresentation
     */
    powerAct: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PowercurveDataRepresentation
     */
    gainAct: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PowercurveDataRepresentation
     */
    powerRef: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PowercurveDataRepresentation
     */
    gainRef: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PowercurveDataRepresentation
     */
    filteredWeight: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PowercurveDataRepresentation
     */
    filteredPowerAct: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PowercurveDataRepresentation
     */
    filteredGainAct: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PowercurveDataRepresentation
     */
    filteredPowerRef: Array<number>;
}

/**
 * Check if a given object implements the PowercurveDataRepresentation interface.
 */
export function instanceOfPowercurveDataRepresentation(value: object): value is PowercurveDataRepresentation {
    if (!('windspeed' in value) || value['windspeed'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('powerAct' in value) || value['powerAct'] === undefined) return false;
    if (!('gainAct' in value) || value['gainAct'] === undefined) return false;
    if (!('powerRef' in value) || value['powerRef'] === undefined) return false;
    if (!('gainRef' in value) || value['gainRef'] === undefined) return false;
    if (!('filteredWeight' in value) || value['filteredWeight'] === undefined) return false;
    if (!('filteredPowerAct' in value) || value['filteredPowerAct'] === undefined) return false;
    if (!('filteredGainAct' in value) || value['filteredGainAct'] === undefined) return false;
    if (!('filteredPowerRef' in value) || value['filteredPowerRef'] === undefined) return false;
    return true;
}

export function PowercurveDataRepresentationFromJSON(json: any): PowercurveDataRepresentation {
    return PowercurveDataRepresentationFromJSONTyped(json, false);
}

export function PowercurveDataRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PowercurveDataRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'windspeed': json['windspeed'],
        'weight': json['weight'],
        'powerAct': json['powerAct'],
        'gainAct': json['gainAct'],
        'powerRef': json['powerRef'],
        'gainRef': json['gainRef'],
        'filteredWeight': json['filteredWeight'],
        'filteredPowerAct': json['filteredPowerAct'],
        'filteredGainAct': json['filteredGainAct'],
        'filteredPowerRef': json['filteredPowerRef'],
    };
}

export function PowercurveDataRepresentationToJSON(json: any): PowercurveDataRepresentation {
    return PowercurveDataRepresentationToJSONTyped(json, false);
}

export function PowercurveDataRepresentationToJSONTyped(value?: PowercurveDataRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'windspeed': value['windspeed'],
        'weight': value['weight'],
        'powerAct': value['powerAct'],
        'gainAct': value['gainAct'],
        'powerRef': value['powerRef'],
        'gainRef': value['gainRef'],
        'filteredWeight': value['filteredWeight'],
        'filteredPowerAct': value['filteredPowerAct'],
        'filteredGainAct': value['filteredGainAct'],
        'filteredPowerRef': value['filteredPowerRef'],
    };
}

